import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getMedsInBoxThunk } from "../../../../../redux/PickerTO/Action";
import React from "react";
import { Empty, message } from "antd";
import { MedBoxLog } from "./PickerMedBoxLog.styled";
class PickerMedicineBoxLog extends React.Component {
  state = {
    boxDetails: null,
  };
  componentDidMount = () => {
    let params = {
      access_token: this.props.access_token,
      toNumber: this.props.toNumber ?? null,
    };
    this.props.getMedsInBoxThunk(params).then(() => {
      if (this.props.medBoxLogFailure) {
        message.error(this.props.medBoxLogFailure);
      } else {
        this.setState({
          boxDetails: Array.isArray(this.props.medBoxLogSuccess)
            ? this.props.medBoxLogSuccess
            : [],
        });
      }
    });
  };

  labelValue = (label, value) => {
    return (
      <div className="labelValue">
        <label>{label} </label>
        <p>{value ? value : "-"}</p>
      </div>
    );
  };

  render() {
    return (
      <>
        {this.state.boxDetails?.length ? (
          this.state.boxDetails?.map((k, p) => (
            <MedBoxLog key={p}>
              <div className="toNo">TO #{k.transferOrderNumber}</div>
              <div className="medHeading">
                {k.productName} <span>{k.productCode}</span>
              </div>
              {this.labelValue("Batch :", k.batchNumber)}
              {this.labelValue("BoxNumber :", k.boxNumber)}
              {this.labelValue("Location Type :", k.locationType)}
              {this.labelValue("Rack Location :", k.rackLocation)}
              {this.labelValue("Picked QTY :", k.pickedQuantity)}
              {this.labelValue("Available QTY :", k.availableQuantity)}
            </MedBoxLog>
          ))
        ) : (
          <Empty />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  getMedsInBoxThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PickerMedicineBoxLog)
);
